import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import {
  buttonTypeConstants,
  EMPTY_STRING,
  inventoryConstants,
  toastMessages,
  transactionConstants,
} from "../../../constants";
import { isAllSystemHasSerialNumber, isSpinnerEnabled } from "../../utility";
import Button from "../Buttons/Button";
import ButtonWithToolTip from "../Buttons/ButtonWithToolTip";

const handleIsSubmitButtonDisabled = (props) => {
  const {
    data,
    currentStore,
    spinnerArray,
    submitButton,
    inventoryArray,
    cashTradeOfferValue,
  } = props;
  let isSubmitButtonDisabled = false;
  let submitButtonDisabledReason = EMPTY_STRING;

  if (submitButton.isDisabled) {
    isSubmitButtonDisabled = true;
    submitButtonDisabledReason = EMPTY_STRING;
  } else if (
    inventoryArray.length === 0 ||
    (data && !Number(data.totalItems))
  ) {
    isSubmitButtonDisabled = true;
    submitButtonDisabledReason = toastMessages.PLEASE_SELECT_SOME_PRODUCT;
  } else if (
    cashTradeOfferValue &&
    (cashTradeOfferValue.cashOfferValue <= 0 ||
      cashTradeOfferValue.tradeOfferValue <= 0)
  ) {
    isSubmitButtonDisabled = true;
    submitButtonDisabledReason = toastMessages.CASH_TRADE_OFFER_MIN_VALUE;
  } else if (isAllSystemHasSerialNumber(currentStore, inventoryArray)) {
    isSubmitButtonDisabled = true;
    submitButtonDisabledReason = toastMessages.SERIAL_NUMBER_REQUIRED_BATCH;
  } else if (
    isSpinnerEnabled(spinnerArray, [
      inventoryConstants.ADD_INVENTORY,
      transactionConstants.ADD_TRADE_BATCH_ITEM,
    ])
  ) {
    isSubmitButtonDisabled = true;
    submitButtonDisabledReason = "Processing...";
  }

  return { isSubmitButtonDisabled, submitButtonDisabledReason };
};

const AddInventoryModalSubmitButton = (props) => {
  const {
    className,
    currentStore,
    spinnerArray,
    submitButton,
    cancelButton,
    inventoryArray,
  } = props;
  const { isSubmitButtonDisabled, submitButtonDisabledReason } =
    handleIsSubmitButtonDisabled(props);

  return (
    <Row className={className}>
      <Col
        md={6}
        className="d-flex justify-content-end align-items-center ps-0"
      >
        <Button
          type="button"
          className="w-100 "
          label={cancelButton.label}
          handleClick={cancelButton.handleClick}
          buttonType={buttonTypeConstants.GHOST_BUTTON}
          isDisabled={
            cancelButton.isDisabled ||
            isSpinnerEnabled(spinnerArray, [
              inventoryConstants.ADD_INVENTORY,
              transactionConstants.ADD_TRADE_BATCH_ITEM,
            ])
          }
        />
      </Col>
      <Col md={6} className="d-flex align-items-center pe-0">
        <ButtonWithToolTip
          type="submit"
          toolTipRootClassName="w-100"
          className="w-100"
          label={submitButton.label}
          handleClick={submitButton.handleClick}
          isDisabled={isSubmitButtonDisabled}
          tooltipBody={submitButtonDisabledReason}
        />
      </Col>
    </Row>
  );
};

const mapStateToProps = (state) => ({
  inventory: state.inventory,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
});

const mapDispatchToProps = (dispatch) => ({});

//-------Export AddNewUser Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddInventoryModalSubmitButton);
